import { Box, Typography } from "@mui/material";
import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <Box className="error-page">
      <Typography variant="h1" gutterBottom>
        Oops !
      </Typography>
      <Typography variant="body1" gutterBottom>
        Sorry, an unexpected error has occurred.
      </Typography>
      <Typography variant="h6" gutterBottom sx={{ fontStyle: "italic" }}>
        {error.statusText || error.message}
      </Typography>
    </Box>
  );
}
